import { TimeZones } from '../../types'

const getTimeZoneOptions = (timezones: TimeZones): { name: string; value: string }[] => {
  return Object.keys(timezones).map((key) => ({
    name: key,
    value: key,
  }))
}

export { getTimeZoneOptions }
